export default "__VITE_ASSET__CGc9PABL__"